// src/components/FaturamentoModal.js
import React, { useState } from 'react';

function FaturamentoModal({ isOpen, onClose, oportunidade, onConfirmar }) {
  const [observacoes, setObservacoes] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await onConfirmar(observacoes);
      onClose();
    } catch (error) {
      console.error('Erro ao processar faturamento:', error);
      alert('Erro ao processar faturamento!');
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  const getNumeroOS = () => {
    const match = oportunidade.titulo.match(/OS (\d+)/);
    return match ? match[1] : 'N/A';
  };

  const formatarValor = (valor) => {
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    }).format(valor || 0);
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content modal-faturamento" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>💰 Enviar para Faturamento</h2>
          <button className="modal-close" onClick={onClose}>×</button>
        </div>

        <div className="modal-body">
          <div className="faturamento-info">
            <div className="info-row">
              <span className="label">📋 OS:</span>
              <span className="value">#{getNumeroOS()}</span>
            </div>
            <div className="info-row">
              <span className="label">👤 Cliente:</span>
              <span className="value">{oportunidade.cliente_nome}</span>
            </div>
            <div className="info-row">
              <span className="label">💵 Valor:</span>
              <span className="value valor-destaque">{formatarValor(oportunidade.valor_real)}</span>
            </div>
          </div>

          <div className="alert-info">
            <p>
              <strong>📱 A diretoria será notificada via WhatsApp</strong>
            </p>
            <p style={{ fontSize: '14px', marginTop: '8px' }}>
              ⏰ Lembretes automáticos serão enviados Segunda a Sexta às 10:00 e 14:00 
              até que esta OS seja faturada.
            </p>
          </div>

          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="observacoes">
                📝 Observações (opcional)
              </label>
              <textarea
                id="observacoes"
                name="observacoes"
                value={observacoes}
                onChange={(e) => setObservacoes(e.target.value)}
                placeholder="Adicione informações importantes sobre o faturamento..."
                rows="4"
                disabled={loading}
                style={{
                  width: '100%',
                  padding: '10px',
                  border: '2px solid #e0e0e0',
                  borderRadius: '8px',
                  fontSize: '14px',
                  resize: 'vertical'
                }}
              />
            </div>

            <div className="modal-footer">
              <button 
                type="button" 
                className="btn-cancelar" 
                onClick={onClose}
                disabled={loading}
              >
                Cancelar
              </button>
              <button 
                type="submit" 
                className="btn-confirmar"
                disabled={loading}
                style={{
                  background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
                  color: 'white'
                }}
              >
                {loading ? '⏳ Enviando...' : '✅ Confirmar Faturamento'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default FaturamentoModal;
